/* ===========================================================
   ReviewList — renders a list of API ReviewOut rows on the PDP.
   =========================================================== */
import React from "react";
import { StarRating } from "@/components/product-card";

function timeAgo(iso) {
  if (!iso) return "";
  const then = new Date(iso).getTime();
  const diff = Date.now() - then;
  const minutes = Math.floor(diff / 60_000);
  if (minutes < 1) return "just now";
  if (minutes < 60) return minutes + " min ago";
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return hours + " hr ago";
  const days = Math.floor(hours / 24);
  if (days < 7) return days + " day" + (days === 1 ? "" : "s") + " ago";
  const weeks = Math.floor(days / 7);
  if (weeks < 4) return weeks + " wk ago";
  return new Date(iso).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" });
}

function ReviewList({ items, loading }) {
  if (loading) {
    return <div className="review-list-empty" style={{ padding: 24, color: "var(--ink-3)" }}>Loading reviews…</div>;
  }
  if (!items || items.length === 0) {
    return (
      <div className="review-list-empty" style={{ padding: 24, color: "var(--ink-3)" }}>
        No reviews yet — be the first to share your experience.
      </div>
    );
  }

  return (
    <div className="review-list">
      {items.map((r) => (
        <article key={r.id} className="review-card">
          <header className="review-card-head">
            <div>
              <div className="review-author">{r.author?.full_name || "Customer"}</div>
              <div className="review-meta">
                {(r.author?.role || "customer").toUpperCase()} · {timeAgo(r.created_at)}
                {r.is_verified_purchase && (
                  <> · <span style={{ color: "#0a0a0a", fontWeight: 500 }}>Verified buyer</span></>
                )}
              </div>
            </div>
            <StarRating value={r.rating} size={13} />
          </header>
          {r.title && <h4 className="review-title">{r.title}</h4>}
          {r.body && <p className="review-content">{r.body}</p>}
        </article>
      ))}
    </div>
  );
}

export { ReviewList };
